module.exports = __webpack_public_path__ + "assets/img/12.0dec0d79.png";